// TODO: remove
export function isValidEmail(email: string): boolean {
  return /^[\w%+.-]+@[\d.a-z-]+\.[a-z]+$/i.test(email)
}
